import { render, staticRenderFns } from "./invoice-failed.vue?vue&type=template&id=64c0619c&scoped=true"
import script from "./invoice-failed.vue?vue&type=script&lang=js"
export * from "./invoice-failed.vue?vue&type=script&lang=js"
import style0 from "./invoice-failed.vue?vue&type=style&index=0&id=64c0619c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c0619c",
  null
  
)

export default component.exports